import { render, staticRenderFns } from "./DelDemo.vue?vue&type=template&id=0794209a"
import script from "./DelDemo.vue?vue&type=script&lang=js"
export * from "./DelDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports